import {
  Button,
  Card,
  Container,
  Divider,
  Grid,
  IconButton, InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { MRT_SortingState, MRT_PaginationState } from "material-react-table";
import React, { useEffect, useMemo, useState } from "react";
import { capitalizeFirstLetter } from "utils/utils";
import PromoItemsService from "../services/promoItems.service";
import MaterialsGridContainer from "./materialsGrid.container";
import PromoItemDetails from "../components/PromoItemDetails.component";
import {
  FilterAlt,
  FindInPageOutlined,
  Search,
} from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";
import {
  PslFiltersContainer,
  defaultFiltersState,
} from "modules/Filters/containers/PslFilters.container";
import { useFeatures } from "modules/FeatureManagement/service/featureManagement.hooks";
import { useActiveUser } from "modules/User/activeUser";
import { IUserScopeCompany, UserService } from "modules/User/service/user.service";

export const BrowseContainer = (props) => {
  const features = useFeatures();
  const currentUser = useActiveUser();
  const queryClient = useQueryClient();

  let [searchParams, setSearchParams] = useSearchParams();
  const [filtersOpen, setFiltersOpen] = useState(false);
  const storedFilters = window.localStorage.getItem('browse_filters');

  const savedFilters = storedFilters ? JSON.parse(storedFilters) : {};

  const [filters, setFilters] = useState({
    ...defaultFiltersState,
    pslStatuses: [{ id: 1, title: "Approved" }],
    scope: [{ id: "At Market", title: "At Market" }],
    ...savedFilters,
    companies: [], // Always empty
    catalogType: [
      {
        id: 2,
        title: "General Catalogues",
      },
    ],
  });

  const [selectedCategory, setSelectedCategory] = useState<string | number>(
    searchParams.get("catId")
  );
  const [selectedPromoItem, setSelectedPromoItem] = useState(null);
  const [activeDrawer, setActiveDrawer] = useState<"media" | "details">(null);

  const [globalFilter, setGlobalFilter] = useState(
    searchParams.get("searchTerm")
  );

  const activeUser = useActiveUser();

  const [sorting, setSorting] = useState<MRT_SortingState>([
    { id: "createdOn", desc: true },
  ]);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 12,
  });
  const {
    data: backendData,
    refetch,
  } = useQuery({
    queryKey: [
      "materials-list",
      //   globalFilter, //re-fetch when global filter changes
      pagination,
      pagination.pageIndex, //re-fetch when page index changes
      pagination.pageSize, //re-fetch when page size changes
      searchParams.toString(), //re-fetch when search params change
      sorting,
      selectedCategory,
      filters,
    ],
    enabled: true,
    retry: 1,
    staleTime: 0, // Always consider data stale to force refetch
    gcTime: 0, // Don't cache data to prevent mixing old and new results
    queryFn: async () => {
      const response = await PromoItemsService.getMaterials({
        ...filters,
        searchTerm: searchParams.get("searchTerm") || null,
        take: pagination.pageSize,
        skip: pagination.pageIndex * pagination.pageSize,
        orderBy: sorting[0]
          ? {
            field: capitalizeFirstLetter(sorting[0].id),
            direction: sorting[0].desc ? "desc" : "asc",
          }
          : null,
        time: "active",
        pslStatuses: [{ id: 1, title: "Approved" }],
        scope: [{ id: "At Market", title: "At Market" }],
      });
      setRowCount(response?.total || 0); //set the total row count for pagination
      return response;
    },
  });

  useEffect(() => {
    const getcompCodeId = async () => {

      //const compCodes = await UserService.fetchUserScope(true) as IUserScopeCompany[];
      //const prefferedCompCode = compCodes.filter(item => item.code === currentUser.userPreferredCompanyCode)[0];
      //if (!prefferedCompCode) return; //safety check
      // setFilters(prevState => {
      //   return {
      //     ...prevState,
      //     companies: activeUser.hasAboveMarketRole() ? [] : [{
      //       id: prefferedCompCode?.id, title: `${prefferedCompCode.code} - ${prefferedCompCode.name}`
      //     }],
      //     ...JSON.parse(storedFilters), // this is to ensure we use the stored filters, in case location filter was updated
      //   }
      // })
      await UserService.fetchUserScope(true);
      //       setFilters(prevState => {
      //   return {
      //     ...prevState,
      //     companies: [], // Always empty on initial load for Browse page
      //     ...(storedFilters ? JSON.parse(storedFilters) : {}), // Restore saved filters if available
      //   };
      // }
      // setFilters(prevState => ({
      //   ...prevState,
      //   ...(storedFilters ? JSON.parse(storedFilters) : {}),
      //   companies: [], // keep this LAST so it always wins
      // }));
      setFilters(prevState => ({
        ...prevState,
        companies: [],
      }));
      // console.log("Preferred Company Code:", currentUser.userPreferredCompanyCode);
      // console.log("Authorized Scope:", compCodes);
      // console.log("Preferred Company:", prefferedCompCode);
      // console.log("Stored Filters:", storedFilters);
      // console.log("Above Market:", activeUser.hasAboveMarketRole());
      console.log("Stored Filters:", storedFilters);
    };

    getcompCodeId();

  }, []);

  const searchTerm = searchParams.get("searchTerm");
  useEffect(() => {
    setSelectedPromoItem(null);
    setActiveDrawer(null);
    setPagination(prev => ({
      ...prev,
      pageIndex: 0,
    }));
    refetch();
  }, [searchTerm, refetch]);

  const data = useMemo(() => {
    return backendData?.data || [];
  }, [backendData]);

  const handleSearch = () => {
    setSelectedPromoItem(null);
    setActiveDrawer(null);
    setPagination(prev => ({
      ...prev,
      pageIndex: 0,
    }));

    setSearchParams((oldParams) => {
      let params = new URLSearchParams(oldParams);
      params.set("searchTerm", globalFilter.toString());
      return params;
    });

    queryClient.invalidateQueries({ queryKey: ["materials-list"] });
  }

  return (
    <>
      {/* <PslFiltersContainer
        open={filtersOpen}
        initialData={filters}
        onClose={() => setFiltersOpen(false)}
        onApply={(filters) => {
          window.localStorage.setItem('browse_filters', JSON.stringify(filters));
          setFilters(filters);
          setFiltersOpen(false);
        }}
      /> */}
      <PslFiltersContainer
        open={filtersOpen}
        initialData={filters}
        disableCatalogType={true}
        onClose={() => setFiltersOpen(false)}
        onApply={(filters) => {
          window.localStorage.setItem("browse_filters", JSON.stringify(filters));
          setFilters(filters);
          setFiltersOpen(false);
        }}
      />
      <Card elevation={0} sx={{ p: 3, m: -3, mb: 3 }}>
        <Container maxWidth="xl">
          <Grid container justifyContent={"space-between"}>
            <Grid item xs={12} sx={{ display: "flex" }}>
              <TextField
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleSearch} edge="end">
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                size="small"
                label="Search"
                placeholder="What are you looking for?"
                variant="outlined"
                value={globalFilter}
                onChange={(e) => {
                  setGlobalFilter(e.target.value);
                  if (e.target.value === "") {
                    setSearchParams((oldParams) => {
                      let params = new URLSearchParams(oldParams);
                      params.delete("searchTerm");
                      return params;
                    });
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
                sx={{ flex: "1 1 250px" }}
              />
              <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
              <Button
                // color="inherit"
                variant="outlined"
                onClick={() => {
                  setFiltersOpen(true);
                }}
                startIcon={<FilterAlt />}
              >
                Filter
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Card>
      <Container maxWidth="xl">
        <PromoItemDetails
          open={!!selectedPromoItem && activeDrawer === "details"}
          promoItem={selectedPromoItem}
          onClose={() => {
            setSelectedPromoItem(null);
            setActiveDrawer(null);
          }}
        />
        {backendData?.total === 0 ? (
          <>
            <Typography variant="h1" textAlign={"center"}>
              <FindInPageOutlined sx={{ fontSize: "3rem" }} />
            </Typography>
            <Typography variant="h6" textAlign={"center"}>
              No results were found to match your search.
            </Typography>
            <Typography variant="body2" textAlign={"center"}>
              Try modifying your search criteria or create new material.
            </Typography>
          </>
        ) : (
          <MaterialsGridContainer
            data={data}
            onRefetch={refetch}
            count={backendData?.total ?? 0}
            page={
              !backendData ? 0 : Math.ceil(backendData.skip / backendData.take)
            }
            onPageChange={(e, value) => {
              setPagination({
                ...pagination,
                pageIndex: value,
              });
            }}
            onPreview={(promoItem) => {
              setSelectedPromoItem(promoItem);
              setActiveDrawer("details");
            }}
            onRowsPerPageChange={(e) => {
              setPagination({
                ...pagination,
                pageSize: parseInt(e.target.value, 10),
                pageIndex: 0, // Reset to first page when changing page size
              });
            }}
            rowsPerPage={pagination.pageSize}
          />
        )}
        {/* <Grid container>
        <Grid item xs={12}>
        </Grid>
      </Grid> */}
      </Container>
    </>
  );
};

export default BrowseContainer;
